import { defaultMeta } from '@/constants/defaultMeta';
import { sortBy } from '@/lib/sortBy';
import { useQuery } from '@/react-query/hooks/useQuery/useQuery';
import { hoslogPostQueries } from '@/services/hoslog-plans/hoslog-plans.queries';
import { StatusType } from '@/services/hoslog-plans/hoslog-plans.types';
import { useSearch } from '@tanstack/react-router';

const useParams = () => {
  const search = useSearch({ from: '/(app)/configuration-management/hoslog-plans/' });
  const { page, fetch, sort } = search;
  return {
    row: page,
    fetch: fetch ?? 10,
    search: search.q ?? '',
    sort,
  };
};
export const useHoslogPlansList = (type: StatusType, enabled: boolean) => {
  const { sort, ...params } = useParams();
  const { data, isLoading } = useQuery({
    ...hoslogPostQueries.list(type, params),
    enabled,
    select: (res) => ({
      ...res,
      data: sortBy(res.data, sort),
    }),
  });

  return { hoslogPlansList: data?.data || [], isLoading, meta: data?.meta?.pagination ?? defaultMeta };
};
